import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ConfigService } from 'src/app/services/config.service';

@Component({
  selector: 'app-endereco',
  templateUrl: './endereco.component.html',
  styleUrls: ['./endereco.component.css']
})
export class EnderecoComponent implements OnInit {

  config: any = {}

  constructor(
    private configService: ConfigService,
    private titleService: Title
  ) {
    this.getConfig()
  }

  ngOnInit(): void {
  }

  getConfig() {
    this.configService.config().subscribe(
      data => {
        this.config = data
        this.titleService.setTitle('Endereço | ' + data.nome)
      }, err => {
      }
    )
  }

}
